export const browserDetector = {
  data() {
    return {
      browser: this.detectBrowser(),
    }
  },
  methods: {
    detectBrowser() {
      const { userAgent } = navigator
      let browserName = 'Unknown'
      let browserVersion = ''

      if (/Chrome/.test(userAgent) && !/Chromium|Edge|Edg|OPR|Samsung|Brave/.test(userAgent)) {
        browserName = 'Chrome'
        browserVersion = userAgent.match(/Chrome\/([0-9.]+)/)[1]
      } else if (/Firefox/.test(userAgent) && !/Seamonkey/.test(userAgent)) {
        browserName = 'Firefox'
        browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)[1]
      } else if (/Edg/.test(userAgent)) {
        browserName = 'Edge'
        browserVersion = userAgent.match(/Edg\/([0-9.]+)/)[1];
      } else if (/Safari/.test(userAgent) && !/Chrome|Chromium|Edge|Edg|OPR|Samsung|Brave/.test(userAgent)) {
        browserName = 'Safari'
        browserVersion = userAgent.match(/Version\/([0-9.]+)/)?.[1] || ''
      } else if (/OPR/.test(userAgent) || /Opera/.test(userAgent)) {
        browserName = 'Opera'
        browserVersion = userAgent.match(/(?:OPR|Opera)\/([0-9.]+)/)[1]
      } else if (/SamsungBrowser/.test(userAgent)) {
        browserName = 'Samsung Internet'
        browserVersion = userAgent.match(/SamsungBrowser\/([0-9.]+)/)[1]
      } else if (/Trident/.test(userAgent)) {
        browserName = 'Internet Explorer'
        browserVersion = userAgent.match(/rv:([0-9.]+)/)[1]
      } else if (/UCBrowser/.test(userAgent)) {
        browserName = 'UC Browser';
        browserVersion = userAgent.match(/UCBrowser\/([0-9.]+)/)[1]
      }

      return {
        name: browserName,
        version: browserVersion,
        userAgent,
        // Yaygın tarayıcı kontrolleri
        isChrome: browserName === 'Chrome',
        isFirefox: browserName === 'Firefox',
        isEdge: browserName === 'Edge',
        isSafari: browserName === 'Safari',
        isOpera: browserName === 'Opera',
        isIE: browserName === 'Internet Explorer',
        // Mobil tarayıcıları kontrol etme
        isMobileSafari: browserName === 'Safari' && /iPhone|iPad|iPod/.test(userAgent),
        isSamsungBrowser: browserName === 'Samsung Internet',
        isUCBrowser: browserName === 'UC Browser',
      }
    },
    // Tarayıcı özelliklerini test etme
    isWebpSupported() {
      const elem = document.createElement('canvas')
      if (elem.getContext && elem.getContext('2d')) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
      }
      return false
    },
    isTouchEnabled() {
      return ('ontouchstart' in window)
        || (navigator.maxTouchPoints > 0)
        || (navigator.msMaxTouchPoints > 0)
    },
  },
}
